import { compose } from 'redux';
import { connect } from 'react-redux';
import { withFetch } from '@flowio/redux-fetch';
import { setOverlayProps } from '@flowio/redux-form-overlay';
import { browserHistory } from 'react-router';
import get from 'lodash/get';

import FormName from '../constants/FormName';
import PriceBookList from '../components/PriceBookList';
import { getOrganization, fetchOrganization } from '../../organization';
import fetchPriceBookExportTypes from '../actions';
import { getPriceBookExportOptions } from '../selectors';
import {
  readCurrencies,
  readPriceBooksByOrg,
} from '../../resources/operations';
import {
  getCurrencies,
  getPriceBooks,
  getIsFirstPriceBooksPage,
  getIsLastPriceBooksPage,
  getCurrentPriceBooksPage,
} from '../../resources/selectors';
import { getUserEmail } from '../../console';

const fetchAsyncState = (dispatch, getState, ownProps) => {
  const { organization } = ownProps.params;
  const { pageNumber } = ownProps.location.query;

  return Promise.all([
    dispatch(readCurrencies()),
    dispatch(readPriceBooksByOrg({ organizationId: organization, pageNumber: pageNumber || 1 })),
    dispatch(fetchOrganization(organization)),
    dispatch(fetchPriceBookExportTypes(organization)),
  ]);
};

const mapStateToProps = (state) => ({
  currencies: getCurrencies(state),
  priceBooks: getPriceBooks(state),
  firstPage: getIsFirstPriceBooksPage(state),
  lastPage: getIsLastPriceBooksPage(state),
  organization: getOrganization(state),
  pageNumber: getCurrentPriceBooksPage(state),
  email: getUserEmail(state),
  priceBookExportTypes: getPriceBookExportOptions(state),
});

const toInitialValues = (organizationId, priceBook) => ({
  currency: get(priceBook, 'currency'),
  includes: get(priceBook, 'includes.key'),
  key: get(priceBook, 'key'),
  name: get(priceBook, 'name'),
  organizationId,
  status: get(priceBook, 'status'),
});

const mapDispatchToProps = (dispatch, props) => ({
  onUploadPriceBook(organizationId) {
    dispatch(setOverlayProps(FormName.IMPORT_PRICE_BOOK_FORM, {
      initialValues: {
        organizationId,
      },
      saveButton: {
        content: 'Upload',
        intent: 'primary',
      },
      open: true,
      title: 'Upload Price Book',
    }));
  },
  onExportPriceBook(organization, priceBook, email) {
    dispatch(setOverlayProps(FormName.EXPORT_PRICE_BOOK_FORM, {
      initialValues: {
        organization,
        priceBookKey: priceBook.key,
        email,
        itemIdentifier: 'item_number',
      },
      priceBook,
      open: true,
      title: 'Export Price Book',
    }));
  },
  onAddPriceBook(organizationId) {
    dispatch(setOverlayProps(FormName.UPSERT_PRICE_BOOK_FORM, {
      initialValues: toInitialValues(organizationId),
      open: true,
      title: 'Add Price Book',
    }));
  },
  onDeletePriceBook(organizationId, priceBook) {
    dispatch(setOverlayProps(FormName.DELETE_PRICE_BOOK_FORM, {
      caption: 'Delete Price Book',
      initialValues: {
        key: priceBook.key,
        organizationId,
      },
      open: true,
      priceBook,
      title: 'Delete Price Book',
    }));
  },
  onEditPriceBook(organizationId, priceBook) {
    dispatch(setOverlayProps(FormName.UPSERT_PRICE_BOOK_FORM, {
      initialValues: toInitialValues(organizationId, priceBook),
      open: true,
      title: 'Edit Price Book',
    }));
  },
  onRequestPage(pageNumber) {
    const { location } = props;
    browserHistory.push({
      pathname: location.pathname,
      query: {
        ...location.query,
        pageNumber,
      },
    });
  },
  onRequestDetails(organization, priceBookKey) {
    browserHistory.push(`/${organization.id}/price-books/${priceBookKey}`);
  },
});

export default compose(
  withFetch(fetchAsyncState),
  connect(mapStateToProps, mapDispatchToProps),
)(PriceBookList);
